import { type BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  appointments: [
    {
      text: i18n.global.t('eServices'),
      href: '/dashboard/portal-services',
    },
    {
      text: i18n.global.t('appointments'),
      href: '/',
    },
  ] as BreadCrumbModel[],
  requestNewAppointment: [
    {
      text: i18n.global.t('appointments'),
      href: '/',
    },
    {
      text: i18n.global.t('requestNewAppointment'),
    },
  ] as BreadCrumbModel[],

  appointmentDetails: [
    {
      text: i18n.global.t('appointments'),
      href: '/',
    },
    {
      text: i18n.global.t('appointmentDetails'),
    },
  ] as BreadCrumbModel[],
};

export default Breadcrumbs;
